import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-6" }
const _hoisted_3 = { class: "col-lg-6" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = { class: "col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DefaultBadges = _resolveComponent("DefaultBadges")!
  const _component_SoftBadges = _resolveComponent("SoftBadges")!
  const _component_RoundedPillBadges = _resolveComponent("RoundedPillBadges")!
  const _component_RoundedPillBadgesTwo = _resolveComponent("RoundedPillBadgesTwo")!
  const _component_HeadingsBadges = _resolveComponent("HeadingsBadges")!
  const _component_OtherBadges = _resolveComponent("OtherBadges")!
  const _component_BadgesWithIcons = _resolveComponent("BadgesWithIcons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DefaultBadges)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_SoftBadges)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_RoundedPillBadges)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_RoundedPillBadgesTwo)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_HeadingsBadges)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_OtherBadges)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_BadgesWithIcons)
    ])
  ]))
}